import {StateProvider} from "@uirouter/angularjs";
import {AchievementDialogService} from "./service/AchievementDialogService";

/** @ngInject */
export function routerConfig($stateProvider: StateProvider) {
    $stateProvider.state("achievements", {
        /** @ngInject */
        onEnter: (achievementDialogService: AchievementDialogService) => {
            achievementDialogService.open();
            return false;
        }
    });
}